export default {"src":"/_next/static/media/eu-flag-icon.84d13232.svg","height":43,"width":64,"blurWidth":0,"blurHeight":0};